import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { LinhaProducao } from '../linha-producao';
import { LinhaProducaoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class LinhaProducaoCrudHttpService implements Crud<LinhaProducao> {
    resource = 'linhaproducao';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todas as linhas de produção cadastradas */
    search(): Observable<LinhaProducao[]> {
        return this.crudService.search<LinhaProducao>(this.resource);
    }

    searchWithFilter(filter: LinhaProducaoFilter): Observable<LinhaProducao[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<LinhaProducao>(this.resource, {params});
    }

    /** Procura uma única linha de produção através do seu ID */
    find(id: number): Observable<LinhaProducao> {
        return this.crudService.find<LinhaProducao>(this.resource, id);
    }

    /** Carrega uma única linha de produção através do seu ID */
    load(id: number): Observable<LinhaProducao> {
        return this.crudService.load<LinhaProducao>(this.resource, id);
    }

    /** Insere uma nova linha de produção */
    insert(entity: LinhaProducao): Observable<LinhaProducao> {
        return this.crudService.insert<LinhaProducao>(this.resource, entity);
    }

    /** Altera uma linha de produção existente */
    update(entity: LinhaProducao): Observable<LinhaProducao> {
        return this.crudService.update<LinhaProducao>(this.resource, entity);
    }

    /** Exclui uma linha de produção através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
